import { ArrowBack } from "@mui/icons-material";
import Styles from "./styles.module.scss";
import { useState } from "react";

const ProductCard = ({ title, content, logo, logoHeight, url }) => {
  const [isHoverCard, setIsHoverCard] = useState(false);

  return (
    <div className={`${Styles.container} ${Styles[isHoverCard]}`}>
      <div
        className={`${Styles.top}`}
        onMouseEnter={() => (url ? setIsHoverCard(true) : {})}
        onMouseLeave={() => (url ? setIsHoverCard(false) : {})}
        style={{ overflow: isHoverCard ? "unset" : "hidden" }}
      >
        <div className={Styles.content}>
          <div className={Styles.title}>{title}</div>
          <div className={Styles.text}>{content}</div>
        </div>
        <div className={Styles.logo}>
          <img
            className={Styles.img}
            src={logo}
            alt="logo"
            style={{ maxHeight: logoHeight }}
          />
        </div>
        <div
          className={`${Styles.bgFilterSpread} ${Styles[isHoverCard]} `}
        ></div>

        {isHoverCard && <div className={Styles.bgFilterBottom}></div>}
        <div
          className={`${Styles.buttonDetail} ${Styles[isHoverCard]}`}
          onClick={() => window.open(url, "_blank")}
        >
          <span>Lihat Lebih Detail</span>
          <ArrowBack color="#fff" className={Styles.arrowIcon} />
        </div>
        <div className={`${Styles.bottom} ${Styles[isHoverCard]} `} />
      </div>
    </div>
  );
};

export default ProductCard;
